import { TCommonTypes } from './common';

export enum AccordionProfileEnum {
  DEFAULT = 'DEFAULT',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export type TAccordionProps = TCommonTypes & {
  primaryLabel?: string;
  secondaryLabel?: string;
  customLabel?: React.ReactNode;
  distanceLabel?: string | React.ReactNode;
  children?: React.ReactNode;
  isDisabled?: boolean;
  defaultOpen?: boolean;
  accordionProfile?: AccordionProfileEnum;
  triggerClassName?: string;
  contentClassName?: string;
  toggleClassName?: string;
  onClick?: () => void;
  isOpen?: (open: boolean) => void;
  hideDropdownIcon?: boolean;
  reservationInfoBar?: React.ReactNode;
};
